<template>
  <div class="header">
    <div>
      <div class="nav flex justify-between items-center">
        <div class="nav__logo">
          <a class="logo link fw6 ttc flex items-center" :href="mainSite">
            <img class="logo__img" src="https://cdn.milkbox.com/brands/width/e6d73413-f0a1-4743-91cb-4f6d8f74c5e6/logo.png">
        <!--<span class="logo__text">{{siteName}}</span>-->
          </a>
        </div>
        <div class="navigation">
          <ul class="header-links">
            <li>
              <a :href="aboutLink" class="header-link">What is +VPN?</a>
            </li>
            <li>
              <a :href="homePriceLinkLink" class="header-link">Pricing</a>
            </li>
            <li>
              <a :href="featuresLink" class="header-link">Features</a>
            </li>
            <li>
              <router-link class="header-link" :to="{name: 'home'}">
                Support
              </router-link>
            </li>
            <li>
              <a :href="loginLink" class="header-link">My Account</a>
            </li>
          </ul>
          <div class="language-component">
            <component v-bind:is="languageDropdownComponent"></component>
          </div>
          <a :href="signupLink" class="button">Get Started</a>
        </div>
      </div>

      <div class="stage">
        <div class="row-container page-head">
          <h1 class="stage__title">What is your Question?</h1>
<!--          <h5 class="stage_title&#45;&#45;sub">{{$t('headerTitleDescription')}}</h5>-->
        </div>
        <component v-bind:is="searchBarComponent"></component>
        <div class="row-container">
          <p class="stage__text">
            <span
              class="stage__text__question"
            >{{$t('incorrectPopularQuestion')}}:</span>
            <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[0]}-${popularQuestionOne.title.replace(/ /g, '-')}`}"
            >{{$t('popQues1')}}</router-link>
            <span class="">&nbsp;|&nbsp;</span>
            <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[1]}-${popularQuestionTwo.title.replace(/ /g, '-')}`}"
            >{{$t('popQues2')}}</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getComponent, getSpecificArticleFromStore } from '@/utils/common';
export default {
  data: () => {
    return {
      showMembersBar: false
    };
  },
  computed: {
    languageDropdownComponent() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    mainSite() {
      return `https://www.${this.$store.state.siteDetails.domain_name}`;
    },
    aboutLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/about.html`;
    },
    featuresLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/features.html`;
    },
    homePriceLinkLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/index.html#price`;
    },
    loginLink() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/login`;
    },
    MALink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}`;
    },
    signupLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/signup`;
    },
    logoUrl() {
      return this.$store.state.siteDetails.logo_url;
    },
    popularQuestionOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || { title: '' };
    },
    popularQuestionTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || { title: '' };
    },
    searchBarComponent() {
      return getComponent(this.$store.getters.flowObject, 'searchBar');
    }
  }
};
</script>

<style lang="scss" scoped>
.block_container {
  max-width: 1264px;
  margin: 0 auto;
}
.header {
  position: relative;
  padding: 15px 0 0;
  margin: 0 0 50px;
  &:before {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 300px;
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg width='1366' height='270' viewBox='0 0 1366 270' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='1366' height='240' fill='%233638DC'/%3E%3Cpath d='M688.012 82.3389C-25.6197 82.3389 -483.09 206.158 -622.621 268.068H1987.1C1851.42 206.158 1401.64 82.3389 688.012 82.3389Z' fill='%233E3EFF'/%3E%3Cpath d='M148.753 142.58C-167.679 104.78 -361.548 227.395 -420.178 267.976H1694.85L1783.88 240.05C1800.53 181.004 1545.46 89.7571 1286.61 160.856C963.062 249.729 530.935 188.234 148.753 142.58Z' fill='%236161FF'/%3E%3Cpath d='M686.854 240.921C116.308 240.921 -249.438 259.703 -360.992 269.094H1725.47C1616.99 259.703 1257.4 240.921 686.854 240.921Z' fill='%23F7F7FF'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 100%;
    z-index: 1;
  }
}
.navigation {
  display: block;
  .button {
    display: inline-block;
    background: #fff;
    color: #3638DC;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 800;
    text-decoration: none;
    padding: 11px 20px;
    margin: 0 0 0 20px;
    &:hover {
      opacity: .9;
    }
  }
}
.nav {
  position: relative;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 15px 30px;
  z-index: 5;
}
.nav__links {
  position: relative;
  top: 1rem;
  padding-right: 0.4rem;
}
.logo__img {
  height: 40px;
  display: inline-block;
}
.logo__text {
  font-size: 19.5px;
  font-weight: 400;
  margin-left: 1.5rem;
}
.header-links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: none;
  flex-direction: row;
  li {
    padding: 0 15px;
  }
  a {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    padding: 0 5px;
    border-bottom: 2px solid transparent;
    display: inline-block;
    text-decoration: none;
    &:hover {
      border-bottom: 2px solid #fff;
      text-decoration: none;
    }
  }
}
.stage {
  text-align: center;
  position: relative;
  padding: 0 15px;
  z-index: 2;
  .link:hover {
    text-decoration: underline;
  }
}
.stage__title {
  font-size: 25px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-style: italic;
  text-transform: uppercase;
  margin-bottom: 40px;
  color: #fff;
}
.stage__text {
  margin: 1rem 0 0;
  font-size: 16px;
  color: #18214F;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  .link {
    color: #3E3EFF;
  }
  .stage__text__question {
    display: inline-block;
    font-weight: 600;
  }
}
@media (min-width: 480px) {
  .logo__img {
    height: 40px;
  }
  .navigation {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .stage__title {
    font-size: 38px;
  }
  .stage__text {
    margin: 1.5rem 0 0;
    font-size: 18px;
  }
}
@media (min-width: 992px) {
  .nav {
    max-width: 100%;
    padding: 0 40px 50px;
  }
  .header {
    padding: 40px 0 0;
  }
}
@media (min-width: 1200px) {
  .header-links {
    display: flex;
  }
}
</style>
